export default {
    getCustomerContractStatuses: { method: 'get', url: 'emcadmin/customers/contract-statuses' },
}
